import {FulfillmentType} from "../restaurant";
import {MatchingFulfillmentType} from "@/data/entities/product/index";
import {Product} from "@/data/entities/menu";

export const getMatchingFulfillmentType = (
    fulfillmentType: FulfillmentType,
    productAvailability: string[],
): MatchingFulfillmentType => {
    const match = productAvailability.includes(fulfillmentType.toLowerCase());
    const otherType = !match
        ? ((productAvailability.find(a => a !== fulfillmentType) ?? null) as (FulfillmentType | null))
        : null;
    return {match, otherType: (otherType?.toUpperCase() || null) as (FulfillmentType | null)};
};

export const placeholderProduct: Product = {
    id: -1,
    externalId: "",
    number: "",
    name: "",
    description: "",
    price: "",
    priceTakeaway: "",
    deposit: "",
    vat: 21,
    supFee: "",
    soldout: true,
    availability: [],
    flags: [],
    images: [],
    optionGroupIds: [],
};